import { Logo } from '@taskall/react';
import { cx } from '@taskall/ui';

/** Marca oficial TaskAll Educação (componente Logo do design system). */
export function Brand({ size = 'md', className }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const h = size === 'lg' ? 'h-[68px]' : size === 'sm' ? 'h-[30px]' : 'h-10';
  return <Logo className={cx(h, 'w-auto self-start text-[var(--taskall-content-primary)]', className)} title="TaskAll Educação" />;
}
